<template>
  <div class="seatContainer">
    <el-row style="width:85%;margin:0 auto;">
      <el-col :span="24" class="seatInfo">
        <p>教室：{{detall.name}}</p>
        <p>时间：{{detall.time}}</p>
        <p>科目级别：{{detall.subjectName}}&nbsp;&nbsp;{{detall.subjectLevelName}}</p>
        <p>考点：{{detall.placeName}}</p>
      </el-col>
    </el-row>
    <p style="text-align:center;padding-top:30px;">选择座位（点击下方序号按钮选择座位）</p>
    <div class="iconSeat">
      <div>
        <img src="../../static/img/seat.png">
        <p>可选</p>
      </div>
      <div>
        <img src="../../static/img/seat_active.png">
        <p>当前选择</p>
      </div>
      <div>
        <img src="../../static/img/seat_select.png">
        <p>不可选</p>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <div style="padding:30px 0;background:#eee;">
          <ul class="selectSeat">
            <!-- <li class='icon_active'><i class='iconfont icon-zuowei '></i></li>
            <li><i class='iconfont icon-zuowei'></i></li>-->
            <li
              class="selectList"
              v-for="(item,index) in seatData"
              :bind="index"
              :key="index"
              @click="chooseSeat(index)"
            >
              <img src="../../static/img/seat.png" v-show="item==1">
              <img src="../../static/img/seat_active.png" v-show="item==2">
              <img src="../../static/img/seat_select.png" v-show="item==3">
              <p v-if="index<9">0{{index+1}}</p>
              <p v-else>{{index+1}}</p>
            </li>
          </ul>
        </div>
        <div style="text-align:center;padding:20px 0;">
          <button class="selectBtn" @click="selectBtn()">立即选座</button>
          <button class="selectBtn goback_infobtn" @click="()=>{this.$router.go(-1)}">返回</button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      seatList: [],
      select: [],
      seatData: [],
      detall: {}
    };
  },
  created() {
    sessionStorage.getItem("detall");
    console.log(sessionStorage.getItem("detall"));
    this.detall = JSON.parse(sessionStorage.getItem("detall"));
    // this.id = this.$route.query.id;
    // this.signId = this.$route.query.signId;
    // this.name = this.$route.query.name;
    // this.time = this.$route.query.time;
    // this.address = this.$route.query.address;
    // this.subjectName = this.$route.query.subjectName;
    // this.subjectLevelName = this.$route.query.subjectLevelName;
    console.log(this.seatList.length);
    // this.countList = this.$route.query.count
    for (let i = 0; i < this.detall.count; i++) {
      this.seatList.push(1);
       if(this.seatList.length==this.detall.count){
          this.seatInfo();
       }
    }
  },
  methods: {
    seatInfo() {
      console.log(1111);
      let me = this;
      console.log(this.seatList);
      window.Global.get(
        "/choose/seatInfo",
        { classroomId: this.detall.id },
        rs => {
          console.log(rs.data);
          if (rs.data.success) {
            this.select = rs.data.result;
            rs.data.result.map((item, index) => {
              me.seatList[item - 1] = 3;
            });
            this.seatData = this.seatList;
            console.log(66666, this.seatList);
          }
        }
      );
      console.log(me.seatList);
    },
    chooseSeat(id) {
      this.seatData = [];
      console.log(id);
      this.seatNo = id;
      console.log(this.seatNo);
      this.seatData = this.seatList.map((item, index) => {
        if (item == 3) {
          item = 3;
        } else if (id == index) {
          item = 2;
        } else {
          item = 1;
        }
        return item;
      });
      console.log(this.seatData);
    },
    selectBtn() {
      let me = this;
      let chooseList = {
        classroomId: this.detall.id,
        seatNo: this.seatNo + 1,
        signId: sessionStorage.getItem('signId')
        // signId: "12ef4ac54f044c15a8c8b2eb212000e0"
      };
      if (this.seatData[this.seatNo] == 2) {
        window.Global.post("/choose/chooseSeat", chooseList, rs => {
          console.log(rs.data);
          if (rs.data.success) {
            me.$message.success(rs.data.message);
            me.$router.push({name:"indexSign"})
          } else {
            me.$message.error(rs.data.message);
          }
        });
      } else if (this.seatData[this.seatNo] == 3) {
        // me.$message.error("该座位已被选,请重新选择");
      } else {
        me.$message.error("未选中座位,请选择座位");
      }
    }
  }
};
</script>   

<style lang="less">
.seatContainer {
  font-size: 12px;
}
.seatInfo {
  display: flex;
  flex-flow: row wrap;
}
.seatInfo > p {
  width: 50%;
  padding: 5px 0;
}
.selectSeat {
  display: flex;
  flex-flow: row wrap;
}
.selectSeat > li {
  width: 10%;
  padding: 10px 0;
  text-align: center;
}
.selectList > img {
  width: 20px;
  height: 20px;
}
.selectBtn {
  padding: 8px 10px;
  background: #9e7536;
  border: 0;
  color: #fff;
}
.iconSeat {
  padding:20px 0;
  display: flex;
  justify-content: center;
}
.iconSeat > div {
  text-align: center;
  padding: 0 8px;
  font-size: 10px;
  color: #666;
}
.iconSeat > div > img {
  width: 15px;
  height: 15px;
}
// .icon-zuowei{
//   color:#ccc;
// }
// .icon_active{
//   .icon-zuowei{
//     color:red;
//   }
// }
.goback_infobtn{
 background:#EEEAE7;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
 
  color:#9E7536;
  cursor: pointer;
  width: 75px;
  margin-left: 80px; 
}
</style>



// WEBPACK FOOTER //
// src/components/selectSeat.vue